module.exports = __webpack_public_path__ + "9db00de322bd8146e972bd777fdd6fab.pdf";